import $ from "jquery";

/*====  Set global variable here ====*/
var config = {
  production: {
    json_api_url: 'https://express-archive-api.printecs.com'
  },
  local: {
    //json_api_url: 'http://localhost:3000'
    json_api_url: 'https://express-archive-api.printecs.com'
    //json_api_url: 'https://express-backend.printecs.com'
  }
}

var globalVar = {
  json_api_url : config.production.json_api_url,
  environment: 'production'
}
// Local environment
if (window.location.hostname === 'localhost') {
  globalVar.json_api_url = config.local.json_api_url;
  globalVar.environment = 'local';
}

$.ajaxSetup({
  statusCode: {
    401: function(){
      localStorage.clear();
      window.location.href = "/";
    },
    403: function(){
      localStorage.clear();
      window.location.href = "/";
    },
    500: function(e){
      if (globalVar.environment !== "local") {
        // send some errors here
      }
    },
  }
});

function authUrl(apiMethod) {
  return globalVar.json_api_url + "/" + apiMethod;
}

function apiUrl(apiMethod) {
  return globalVar.json_api_url + "/api/v1/" + apiMethod;
}

 var requestCounter = 0;
  function addRequest() {
   requestCounter++;
   setTimeout(function() {
    if (requestCounter > 0) {
      $(".loaderContainer").fadeIn();
    }
   }, 400);
 }
 function removeRequest() {
    if (--requestCounter < 0) {
      requestCounter = 0;
    }
    if (requestCounter === 0) {
      $(".loaderContainer").fadeOut();
      $('div.Select-control').css("height", "auto");
    }
 }
 function resetRequests() {
    $(".loaderContainer").fadeOut();
 }
 
export function getUrlParameter(sParam, location) {
  location = location || window.location.search;
  var sPageURL = decodeURIComponent(location.substring(1));
  var sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return false;
};

export function sendRequest(properties) {
  var token = localStorage.getItem("access_token");
  var url = apiUrl(properties.method);
  if (properties.auth) {
    url = authUrl(properties.method);
  }
  addRequest();
  $.ajax({
    url: url,
    type: properties.type,
    data: properties.data,
    dataType: 'json',
    beforeSend: function(xhr) {
      xhr.setRequestHeader('Authorization', "Bearer " + token);
    },
    success: function(data) {
      removeRequest();
      if (typeof properties.success !== "undefined" && properties.success) {
        properties.success(data);
      }
    },
    error: function(xhr, status, err) {
      removeRequest();
      resetRequests();
      console.error(properties.method, status, err.toString());
      if (typeof properties.error !== "undefined" && properties.error) {
        properties.error(err);
      }
    }
  });
}

// Utils

export function getDateStringBegining() {
  return "2016-01-01";
}

export function getDateStringToday() {
  var today = new Date(); 
  return today.toISOString().substr(0, 10);
}

export function getDateStringMonthBefore(n) {
  if (!n) {
    n = 1;
  }
  var monthBefore = new Date();
  monthBefore.setMonth(monthBefore.getMonth() - n); 
  return monthBefore.toISOString().substr(0, 10);
}



// WEBPACK FOOTER //
// ./src/global.js